import React,{ useContext} from 'react';
import AdminContext from '../../context/adminContext/adminContext';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import {
    Button,
    FormControl,
    TextField,
    Grid,
    Switch,
    Typography,
    MenuItem
} from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  botonera : {
    width:'100%',
    display: 'flex',
    justifyContent:'space-between',
    marginTop:'2rem'
  },
  form : {
    width: '100%'
  }
}));


const AntSwitch = withStyles((theme) => ({
  root: {
    width: 28,
    height: 16,
    padding: 0,
    display: 'flex',
  },
  switchBase: {
    padding: 2,
    color: theme.palette.grey[500],
    '&$checked': {
      transform: 'translateX(12px)',
      color: theme.palette.common.white,
      '& + $track': {
        opacity: 1,
        backgroundColor: theme.palette.primary.main,
        borderColor: theme.palette.primary.main,
      },
    },
  },
  thumb: {
    width: 12,
    height: 12,
    boxShadow: 'none',
  },
  track: {
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: theme.palette.common.white,
  },
  checked: {},
}))(Switch);
const ModalCarta = (props) => {
        //RECIBIR PROPS
        const {openModal, setopenModal , item ,setitem, setloading, newItem, setnewItem} = props;
        //CONTEXT
        const adminContext = useContext(AdminContext);
        const {editItem , error, addItem } = adminContext;
        //UTILIZAR ESTILOS
        const classes = useStyles();
        //STATE LOCALES
        
        //FUNCIONES LOCALES
        const handleClose = () => {
          setopenModal(false);
          
          setTimeout(() => {
                setitem({});
                setnewItem({})
            }, 1000);
          
        };
        const handleSubmit = (item ,newItem) => {
            setloading(true)
          
            if(item.nombre){
              editItem(item)
              setopenModal(false)
              setTimeout(() => {
              if(error){
                setloading(false)
              }else{
                setitem({});
               
                setloading(false)
              }
              
              
                }, 1000);
            }
            if(newItem.nombre && newItem.tipo && newItem.categoria){
              addItem(newItem)
              setopenModal(false)
              setTimeout(() => {
                if(error){
                  setloading(false)
                }else{
                  setnewItem({});
               
                  setloading(false)
              }
              
              
                }, 1000);
            }
            setloading(false)
            
          
        }
        const handleChange = (e) => {
         
          setitem({
            ...item,
            [e.target.name] : e.target.value,
            
          })
        
        }
        const handleSwitchChange = e => {
          setitem({
            ...item,
            [e.target.name] : e.target.checked
          })
          
     
        }
        const handleNewChange = e => {
          
          setnewItem({
            ...newItem,
            [e.target.name] : e.target.value
          })
        }
        return (
          <div>
           <Modal
              aria-labelledby="transition-modal-title"
              aria-describedby="transition-modal-description"
              className={classes.modal}
              open={openModal}
              onClose={handleClose}
              closeAfterTransition
              BackdropComponent={Backdrop}
              BackdropProps={{
                timeout: 500,
              }}
            >
              <Fade in={openModal}>
                <div className={classes.paper}>
                    <h2 id="transition-modal-title">{item.hasOwnProperty('nombre') ? `Editar "${item.nombre}"` : 'Agregar nuevo item de carta'}</h2>
                    {item.nombre ? <div>
                     
                        {item ? item.tipo === "ingrediente" ? 
                            <>
                             <FormControl onChange= {handleChange}>
                              <TextField  fullWidth id="nombre" name="nombre" label="Nombre"  defaultValue={item ? item.nombre : null}/>
                              <TextField 
                                fullWidth 
                                id="precio_hamburguesa" 
                                type="number" 
                                name="precio_hamburguesa" 
                                label="Precio en Hamburguesa" 
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                defaultValue={item ? item.precio_hamburguesa : null}  />
                              <TextField
                                fullWidth  
                                id="precio_milanesa" 
                                type="number" 
                                InputLabelProps={{
                                                  shrink: true,
                                                }}
                                name="precio_milanesa" 
                                label="Precio en Milanesa" 
                                defaultValue={item ? item.precio_milanesa : null} />
                              </FormControl>
                              <Typography>STOCK : </Typography>
                              <Grid component="label" container alignItems="center" spacing={1}>
                                  <Grid item>Si</Grid>
                                  <Grid item>
                                    <AntSwitch defaultChecked={item.stock} onChange={handleSwitchChange} name="stock"  />
                                  </Grid>
                                  <Grid item>No</Grid>
                              </Grid>
                            </> : 
                            <>
                               <FormControl onChange= {handleChange}>
                              <TextField fullWidth id="nombre" name="nombre" label="Nombre" defaultValue={item ? item.nombre : null} />
                              <TextField fullWidth id="precio" name="precio" label="Precio" defaultValue={item ? item.precio : null} />
                              </FormControl>
                              <Typography>STOCK : </Typography>
                              <Grid component="label" container alignItems="center" spacing={1}>
                                  <Grid item>Si</Grid>
                                  <Grid item>
                                    <AntSwitch defaultChecked={item.stock} onChange={handleSwitchChange} name="stock"  />
                                  </Grid>
                                  <Grid item>No</Grid>
                              </Grid>
                            </>
                        : null
                        }
                        
                     

    
                    </div> : 
                  
                      <div className={classes.form}   >
                        <TextField 
                          onChange={handleNewChange}
                          fullWidth
                          id="tipo" 
                          name="tipo" 
                          label="Tipo"
                          select
                        >
                          <MenuItem value="plato">Plato</MenuItem>
                          <MenuItem value="bebida">Bebida</MenuItem>
                          <MenuItem value="ingrediente">Ingrediente</MenuItem>
                        </TextField>
                        {newItem.tipo === "ingrediente" ? 
                          <>
                           <TextField fullWidth id="nombre" name="nombre" label="Nombre" onChange={handleNewChange}/>
                              <TextField 
                                onChange={handleNewChange}
                                fullWidth 
                                id="precio_hamburguesa" 
                                type="number" 
                                name="precio_hamburguesa" 
                                label="Precio en Hamburguesa" 
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                />
                              <TextField
                                onChange={handleNewChange}
                                fullWidth  
                                id="precio_milanesa" 
                                type="number" 
                                InputLabelProps={{
                                                  shrink: true,
                                                }}
                                name="precio_milanesa" 
                                label="Precio en Milanesa" 
                                 />
                  
                          </> 
                          : null
                          }
                          {newItem.tipo === "bebida" ?
                          <>
                           <TextField fullWidth id="nombre" name="nombre" label="Nombre" onChange={handleNewChange}/>
                           <TextField fullWidth id="precio" name="precio" label="Precio" onChange={handleNewChange}/> 
                           <TextField 
                                  onChange={handleNewChange}
                                  fullWidth
                                  id="categoria" 
                                  name="categoria" 
                                  label="Categoria"
                                  select
                                >
                          <MenuItem value="cerveza artesanal">Birra Artesanal</MenuItem>
                          <MenuItem value="vinos">Vinos</MenuItem>
                          <MenuItem value="cerveza">Cerveza</MenuItem>
                          <MenuItem value="sin_alcohol">Bebida sin alcohol</MenuItem>
                          <MenuItem value="tragos">Tragos</MenuItem>
                          <MenuItem value="recarga">Recarga</MenuItem>
                          <MenuItem value="adicionales">Adicionales</MenuItem>
                          </TextField>
                          </>
                          : null
                          }
                          {newItem.tipo === "plato" ? 
                            <>
                            <TextField fullWidth id="nombre" name="nombre" label="Nombre" onChange={handleNewChange}/>
                           <TextField fullWidth id="precio" name="precio" label="Precio" onChange={handleNewChange}/> 
                           <TextField 
                                  onChange={handleNewChange}
                                  fullWidth
                                  id="categoria" 
                                  name="categoria" 
                                  label="Categoria"
                                  select
                                >
                          <MenuItem value="hamburguesa">Hamburguesa</MenuItem>
                          <MenuItem value="milanesa">Milanesa</MenuItem>
                          <MenuItem value="cortes de carne">Cortes de carne</MenuItem>
                          <MenuItem value="tapeo">Tapeo</MenuItem>
                          <MenuItem value="ensalada">Ensalada</MenuItem>
                          <MenuItem value="postre">Postres</MenuItem>
                          </TextField>
                            </>
                            : null}
                      
                    </div>

                    }
                     <div className={classes.botonera}>
                    <Button onClick={()=>{handleClose()}} >Cancelar</Button>
                    <Button onClick={()=>{handleSubmit(item, newItem)}} variant="contained" color="primary">Confirmar</Button>
                         </div>  
                   
                </div>
              </Fade>
            </Modal>
          </div>
          
    );
}
 
export default ModalCarta;